import { useEffect } from 'react';
import { useCategories, usePaginateCategories } from 'hooks/categories';

import AsyncTable from 'components/Tables/AsyncTable';
import { useFilters } from 'hooks/filters';

const columns = [
	{
		Header: 'Título',
		accessor: 'title'
	},
	{
		Header: 'Tipo',
		accessor: 'type'
	}
];

const CategoriesTable = () => {
	const { filters } = useFilters();
	const { rows, page, perPage, total, setToDelete, setDeleteModalOpen } =
		useCategories();
	const [paginateCategories, { loading }] = usePaginateCategories();

	const deleteCategory = (id) => {
		setToDelete(id);
		setDeleteModalOpen(true);
	};

	const fetchData = ({ pageSize, pageIndex, search }) => {
		if (pageSize != perPage) pageIndex = 1;
		paginateCategories({
			variables: {
				first: pageSize || perPage,
				page: pageIndex || page,
				search: search || '',
				...filters
			}
		});
	};

	useEffect(() => {
		if (filters && Object.keys(filters).length > 0) {
			paginateCategories({
				variables: {
					first: perPage,
					page,
					...filters
				}
			});
		}
	}, [filters]);

	return (
		<AsyncTable
			fetchData={fetchData}
			isLoaded={!loading}
			data={!loading ? rows : [{}, {}, {}, {}]}
			columns={columns}
			total={total}
			size={perPage}
			asyncPage={page}
			searchByName
			baseRoute="categorias"
			removeAction={deleteCategory}
			linkRow
		/>
	);
};

export default CategoriesTable;
